import { useMemo } from 'react';
import { relativeTimeFromNow } from '@/lib/relative-time';
import { useLocale } from './provider';

/**
 * Date, age and number formatters bound to the active UI locale, so an
 * English UI never shows "vor 3 Minuten" or a German date.
 */
export function useLocaleFormat() {
  const { locale } = useLocale();

  return useMemo(
    () => ({
      ago: (iso: string) => relativeTimeFromNow(iso, locale),
      moment: (iso: string) => new Date(iso).toLocaleString(locale),
      number: (value: number) => value.toLocaleString(locale),
      euro: (amount: number) => amount.toLocaleString(locale, { style: 'currency', currency: 'EUR' }),
    }),
    [locale],
  );
}
